import { Building2 } from 'lucide-react';

interface NoCompanyAccessProps {
  onRetry: () => void;
}

export function NoCompanyAccess({ onRetry }: NoCompanyAccessProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="text-center max-w-md p-6">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <Building2 className="h-6 w-6 text-muted-foreground" />
        </div>
        <h2 className="text-xl font-semibold mb-2">No Company Access</h2>
        <p className="text-muted-foreground mb-4">
          You do not currently have access to any company. Please contact your
          administrator to be granted access.
        </p>
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
